export const media = {
  path: 'media',
  name: 'pbx.media.index',
  component: () => import(/* webpackChunkName: 'pbx-media' */ '@pbx/pages/media/list'),
  meta: {
    title: {
      code: 'pbx.breadcrumb.media.index'
    }
  }
};
